/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Accolade } from './Accolade';
import {
    AccoladeFromJSON,
    AccoladeFromJSONTyped,
    AccoladeToJSON,
    AccoladeToJSONTyped,
} from './Accolade';
import type { PagingOutput } from './PagingOutput';
import {
    PagingOutputFromJSON,
    PagingOutputFromJSONTyped,
    PagingOutputToJSON,
    PagingOutputToJSONTyped,
} from './PagingOutput';

/**
 * 
 * @export
 * @interface ListAccoladesOutputBody
 */
export interface ListAccoladesOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListAccoladesOutputBody
     */
    readonly $schema?: string;
    /**
     * 
     * @type {Array<Accolade>}
     * @memberof ListAccoladesOutputBody
     */
    accolades: Array<Accolade> | null;
    /**
     * Paging Output
     * @type {PagingOutput}
     * @memberof ListAccoladesOutputBody
     */
    pagingOutput: PagingOutput;
}

/**
 * Check if a given object implements the ListAccoladesOutputBody interface.
 */
export function instanceOfListAccoladesOutputBody(value: object): value is ListAccoladesOutputBody {
    if (!('accolades' in value) || value['accolades'] === undefined) return false;
    if (!('pagingOutput' in value) || value['pagingOutput'] === undefined) return false;
    return true;
}

export function ListAccoladesOutputBodyFromJSON(json: any): ListAccoladesOutputBody {
    return ListAccoladesOutputBodyFromJSONTyped(json, false);
}

export function ListAccoladesOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccoladesOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accolades': (json['accolades'] == null ? null : (json['accolades'] as Array<any>).map(AccoladeFromJSON)),
        'pagingOutput': PagingOutputFromJSON(json['paging_output']),
    };
}

export function ListAccoladesOutputBodyToJSON(json: any): ListAccoladesOutputBody {
    return ListAccoladesOutputBodyToJSONTyped(json, false);
}

export function ListAccoladesOutputBodyToJSONTyped(value?: Omit<ListAccoladesOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accolades': (value['accolades'] == null ? null : (value['accolades'] as Array<any>).map(AccoladeToJSON)),
        'paging_output': PagingOutputToJSON(value['pagingOutput']),
    };
}

